import React from "react";
import { Collapse, IconButton } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";

const MAlert = ({ alert, setAlert }) => {
  // 🔒 safety guard (prevents crash)
  if (!alert) return null;

  return (
    <Collapse in={Boolean(alert.show)}>
      <Alert
        severity={alert.type || "info"}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() =>
              setAlert({
                show: false,
                message: "",
                type: "info",
              })
            }
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {alert.message || ""}
      </Alert>
    </Collapse>
  );
};

export default MAlert;
